<template>
  <div id="modal-calc-invoice" class="modal modal_calc-invoice" :class="{ 'modal_calc-invoice--thanks': isThanks }" style="display: none;">
    <div
      v-if="isThanks"
      class="modal__inner"
    >
      <div class="h2">
        Запрос отправлен
      </div>
    </div>

    <div
      v-else
      class="modal__inner"
    >
      <div class="h2">
        ВЫБЕРИТЕ ИНН
      </div>
      <form
        class="form"
        @submit.prevent="createInvoice"
      >
        <div class="field">
          <label class="field__label">ИНН</label>

          <div class="inp-wrap has-success">
            <select class="inp" v-model="inn">
              <option v-for="inn in inns" :value="inn">
                {{ inn }}
              </option>
            </select>
          </div>
        </div>

        <div class="field">
          <button
            type="submit"
            class="btn"
          >
            <span>Выбрать</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      pdfData: String,
      inns: Array
    },
    data() {
      return {
        inn: '',
        isThanks: false
      };
    },
    methods: {
      createInvoice() {
         var self = this;
         var data = {'inn' : this.inn, 'pdfData' : this.pdfData, 'action': 'createInvoice', type: 'hard'};
         fetch('/api/calculators/', {
           method: 'post',
           body: JSON.stringify(data),
           headers: new Headers({
             'Content-Type': 'application/json'
           })
         })
         .then(response => response.json())
         .then((json) => {
           console.log('Response', json);
           self.isThanks = true;
         })
       },
    },
  };
</script>

<style scoped>
  .inp.error {
    border-color: rgb(185, 74, 72);
  }
</style>